import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import StyledImage from "./styled-image"
import Cta from "./cta"
import { kebabCase } from "lodash"

export default function DiningCta() {
  const data = useStaticQuery(graphql`
    {
      wpOption(id: { eq: "cG9zdDo5OA==" }) {
        diningOptions {
          diningCta {
            heading
            content
            cta {
              target
              title
              url
            }
            image {
              altText
              localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(width: 2560)
                }
              }
            }
          }
        }
      } 
      
    }
  `)
  const { heading, content, cta, image } = data?.wpOption?.diningOptions?.diningCta
  return (
    <section
      className={`bg-banner-gradient/10 flex md:flex-row relative flex-col items-center py-8 lg:py-0`}
    >

      <div className={`container`}>
        <div className={`relative grid lg:grid-cols-2 gap-4 lg:gap-x-12 items-center h-full mx-auto`}>
          {(image) ?
            <div className="flex-grow h-full w-full mx-auto lg:mx-0 max-w-sm lg:max-w-none relative">
              <StyledImage
                image={image}
                objectFit="cover"
                objectPosition={"center"}
                className={`w-full aspect-video lg:aspect-auto lg:h-full`} />
            </div>
            : null}
          <div className={`lg:py-8`}>
            {heading ? <div className="mb-2 lg:mb-3">

              {heading ? (
                <h2  id={kebabCase(heading)} className={`mb-1 leading-normal bookmark`}>{heading}</h2>
              ) : null}

            </div> : null}
            {content && (
              <div
                className={`parsed-content mb-2 lg:mb-3`}
                dangerouslySetInnerHTML={{
                  __html: content,
                }}
              />
            )}
            {cta ? (
              <Cta props={cta} />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  )
}